import { Injectable } from '@angular/core'
import { AuthenticationService } from '../authentication/services/authentication.service'
import { DataLayerService } from './datalayer.service'
import { UserProfileService } from '../authentication/services/user-profile.service'

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    constructor(
        private authenticationService: AuthenticationService,
        private dataLayerService: DataLayerService,
        private userProfileService: UserProfileService
    ) {
        // identify newly subscribed users
        authenticationService.signupSuccessful.subscribe(user => {
            this.dataLayerService.push({
                event: 'user.created',
            })
        })

        // identify newly logedin users
        authenticationService.loginSuccessful.subscribe(user => {
            this.dataLayerService.push({
                event: 'user.login',
            })
        })

        this.userProfileService.userProfilePersisted.pipe().subscribe(user => {
            this.dataLayerService.push({
                event: 'user.profile.changed',
            })
        })
    }
}
